import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/Bridge/FakeCollectionABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { sets } from "src/utils/old-version-knight";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { FAKE_NFT_COLLECTION } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, FAKE_NFT_COLLECTION);
  }
  if (!contractReader) {
    throw new Error("Failed to create nft-collection contract reader");
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, FAKE_NFT_COLLECTION);
  }
  if (!contractSender) {
    throw new Error("Failed to create nft-collection contract sender");
  }
  return contractSender;
}

async function assembleCollection(dispatch, helmetTokenId, armorTokenId, weaponTokenId, shieldTokenId, accountAddress) {
  const emit = getContractSender()
    .methods.assembleCollection(helmetTokenId, armorTokenId, weaponTokenId, shieldTokenId)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Assemble Collection");
  await emit;
}

async function disAssembleCollection(dispatch, collectionId, accountAddress) {
  const emit = getContractSender().methods.disassembleCollection(collectionId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Disassemble Collection");
  await emit;
}

async function getBalance(ownerAddress) {
  const balance = await getContractReader().methods.balanceOf(ownerAddress).call();
  return parseInt(balance);
}

async function approveForAll(dispatch, operatorAddress, accountAddress) {
  const emit = getContractSender().methods.setApprovalForAll(operatorAddress, true).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Approve");
  await emit;
}

async function isApprovedForAll(ownerAddress, operatorAddress, accountAddress) {
  return await getContractReader()
    .methods.isApprovedForAll(ownerAddress, operatorAddress)
    .call({ from: accountAddress });
}

async function getCollectionURL(tokenId) {
  const res = await getContractReader().methods.getCollectionURL(tokenId).call();
  return res;
}

async function getCollectionMetadata(collectionId) {
  const res = await getContractReader().methods.getCollectionMetadata(collectionId).call();
  const components = res[0],
    rarity = res[1];
  return {
    armorTokenId: parseInt(components.armorTokenId),
    helmetTokenId: parseInt(components.helmetTokenId),
    shieldTokenId: parseInt(components.shieldTokenId),
    weaponTokenId: parseInt(components.swordTokenId),
    rarity: parseInt(rarity),
    set: sets[1],
  };
}

async function getCollectionExperience(collectionId) {
  const res = await getContractReader().methods.getCollectionExperience(collectionId).call();
  return parseInt(res);
}

async function getTokenURI(collectionId) {
  const res = await getContractReader().methods.tokenURI(collectionId).call();
  return res;
}

async function ownerOf(collectionId) {
  const res = await getContractReader().methods.ownerOf(collectionId).call();
  return res;
}

async function transfer(dispatch, to, tokenId, accountAddress) {
  const emit = getContractSender().methods.transferFrom(accountAddress, to, tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Transfer");
  await emit;
}
async function totalSupply(ownerAddress) {
  const balance = await getContractReader().methods.totalSupply(ownerAddress).call();
  return parseInt(balance);
}

export default {
  ADDRESS: FAKE_NFT_COLLECTION,
  ABI,
  assembleCollection,
  disAssembleCollection,
  getBalance,
  approveForAll,
  isApprovedForAll,
  getCollectionURL,
  getCollectionMetadata,
  getCollectionExperience,
  transfer,
  getTokenURI,
  ownerOf,
  totalSupply,
};
